import { Required } from 'src/shared/components/client-registration/styles';
import styled from 'styled-components';
import { useTrainerFeedbackState } from '../states/trainerFeedbackState';

export const TrainerFeedback = () => {
  const { trainerFeedback, setTrainerFeedback } = useTrainerFeedbackState();

  const maxCount = 200;

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // 글자수 제한
    if (e.target.value.length > maxCount) return;

    setTrainerFeedback(e.target.value);
  };

  return (
    <div className="px-20 py-32 flex flex-col gap-16">
      <div className="flex gap-4">
        <div className="text-[#d7d2de] text-lg font-medium font-['Pretendard Variable']">
          전문가 피드백
        </div>
        <Required>*</Required>
      </div>

      <div className="relative p-16 rounded-8 border-1 border-solid border-[#373245] ">
        <TextArea
          onChange={onChange}
          value={trainerFeedback}
          placeholder="회원에게 전하고 싶은 내용을 적어주세요"
        />
        <Count>{trainerFeedback.length}/200</Count>
      </div>
    </div>
  );
};

const TextArea = styled.textarea`
  width: 100%;
  height: 208px;
  padding-bottom: 16px;
  background-color: transparent;

  // 기본 스타일 제거
  border: none;
  outline: none;

  &::placeholder {
    color: var(--Gray-Scale-700, #595463);
    /* NEW/body_02_regular */
    font-family: 'Pretendard Variable';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }
`;

const Count = styled.div`
  color: var(--Gray-Scale-700, #595463);

  /* NEW/caption_02_regular */
  font-family: 'Pretendard Variable';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;

  position: absolute;
  bottom: 16px;
  right: 16px;
`;
